<template>
    <div class="timeline-area">
        <div class="container-fluid">
            <div class="timeline card-box-style">
                <div class="others-title">
                    <h3>Timeline</h3>
                </div>

                <div class="timeline-wrap">
                    <div class="timeline-item">
                        <div class="text">
                            <h3>Timeline Title</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In quia dicta quisquam nulla tempore numquam, unde sequi. In eius repellat ratione deleniti quo? Magni harum totam temporibus mollitia tempora eos numquam, unde sequi tempore.</p>
                        </div>

                        <div class="icon">
                            <div>
                                <i class='bx bx-badge-check'></i>
                            </div>
                        </div>

                        <div class="time">
                            <time>2018-01-01 Saturday</time>
                        </div>
                    </div>

                    <div class="timeline-item">
                        <div class="text">
                            <h3>Timeline Title</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In quia dicta quisquam nulla tempore numquam, unde sequi. In eius repellat ratione deleniti quo? Magni harum totam temporibus mollitia tempora eos numquam, unde sequi tempore.</p>
                        </div>

                        <div class="icon">
                            <div>
                                <i class='bx bx-badge-check'></i>
                            </div>
                        </div>

                        <div class="time">
                            <time>2019-01-01 Saturday</time>
                        </div>
                    </div>

                    <div class="timeline-item">
                        <div class="text">
                            <h3>Timeline Title</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In quia dicta quisquam nulla tempore numquam, unde sequi. In eius repellat ratione deleniti quo? Magni harum totam temporibus mollitia tempora eos numquam, unde sequi tempore.</p>
                        </div>
                        <div class="icon">
                            <div>
                                <i class='bx bx-badge-check'></i>
                            </div>
                        </div>
                        <div class="time">
                            <time>2020-01-01 Saturday</time>
                        </div>
                    </div>

                    <div class="timeline-item">
                        <div class="text">
                            <h3>Timeline Title</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In quia dicta quisquam nulla tempore numquam, unde sequi. In eius repellat ratione deleniti quo? Magni harum totam temporibus mollitia tempora eos numquam, unde sequi tempore.</p>
                        </div>
                        <div class="icon">
                            <div>
                                <i class='bx bx-badge-check'></i>
                            </div>
                        </div>
                        <div class="time">
                            <time>2021-01-01 Saturday</time>
                        </div>
                    </div>

                    <div class="timeline-item">
                        <div class="text">
                            <h3>Timeline Title</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In quia dicta quisquam nulla tempore numquam, unde sequi. In eius repellat ratione deleniti quo? Magni harum totam temporibus mollitia tempora eos numquam, unde sequi tempore.</p>
                        </div>
                        <div class="icon">
                            <div>
                                <i class='bx bx-badge-check'></i>
                            </div>
                        </div>
                        <div class="time">
                            <time>2022-01-01 Saturday</time>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TimelineContent'
}
</script>

<style lang="scss">
.timeline {
	h3 {
		text-transform: capitalize;
		font-size: 15px;
		font-weight: bold;
		padding: 15px;
	}
	.timeline-wrap {
		display: flex;
		flex-direction: column;
		position: relative;
		margin: 15px;
		&::before {
			content: "";
			display: block;
			position: absolute;
			left: 50%;
			transform: translatex(-50%);
			border: 1px solid rgba(49, 49, 49, 0.5);
			height: calc(100% / 5 * 4);
		}
		.timeline-item {
			display: flex;
			.text {
				flex: 1 1 calc(50% - 50px);
				position: relative;
				box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
			}
			h3 {
				color: var(--white-color);
				background-color: var(--main-color);
				padding: 15px;
				border-top-left-radius: 5px;
				border-top-right-radius: 5px;
			}
			p {
				padding: 15px;
				color: rgba(51, 51, 51, 0.5);
				border-bottom-left-radius: 5px;
				border-bottom-right-radius: 5px;
			}
			.icon {
				flex: 1 1 100px;
				div {
					width: 50px;
					height: 50px;
					border-radius: 50%;
					margin: auto;
					background: #fff;
					box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.18%);
					position: relative;
					i {
						display: block;
						font-size: 1.5rem;
						color: rgb(0, 85, 255);
						text-align: center;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
			.time {
				flex: 1 1 calc(50% - 50px);
				padding-top: 15px;
			}
			&:nth-child(even) {
				flex-direction: row-reverse;
			}
			&:nth-child(even) > div:last-child {
				text-align: end;
			}
			&:nth-child(even) h3::before {
				content: "";
				position: absolute;
				left: -20px;
				border: 10px solid rgba(0, 0, 0, 0);
				border-right-color: var(--main-color);
			}
			&:nth-child(odd) h3::after {
				content: "";
				position: absolute;
				right: -20px;
				border: 10px solid rgba(0, 0, 0, 0);
				border-left-color: var(--main-color);
            }
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .timeline {
		.timeline-wrap {
            &::before {
                display: none;
            }
			.timeline-item {
				flex-flow: column wrap;
                height: auto;
				&:nth-child(even) {
					flex-direction: column;
				}
				&:nth-child(even) > .time:last-child {
					text-align: start;
				}
				&:nth-child(odd) h3::before {
					content: "";
					position: absolute;
					left: -20px;
					border: 10px solid rgba(0, 0, 0, 0);
					border-right-color: black;
				}
				&:nth-child(odd) {
					h3 {
						&::after {
							border: none;
						}
					}
				}
				.icon {
					order: 1;
					flex: 1 1 100%;
					padding-top: 50px;
					width: 100px;
                    div {
                        display: none;
                    }
				}
				.time {
					order: 2;
					flex: 1 1 50px;
					width: calc(100% - 100px);
				}
				.text {
					order: 3;
					flex: 1 1 calc(100% - 50px);
					width: calc(100% - -1px);
				}
			}
		}
	}
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .timeline {
		.timeline-wrap {
			&::before {
				left: 50px;
				height: calc(100% / 5 * 4);
				top: 50px;
			}
			.timeline-item {
				flex-flow: column wrap;
				height: 250px;
				&:nth-child(even) {
					flex-direction: column;
				}
				&:nth-child(even) > .time:last-child {
					text-align: start;
				}
				&:nth-child(odd) h3::before {
					content: "";
					position: absolute;
					left: -20px;
					border: 10px solid rgba(0, 0, 0, 0);
					border-right-color: black;
				}
				&:nth-child(odd) {
					h3 {
						&::after {
							border: none;
						}
					}
				}
				.icon {
					order: 1;
					flex: 1 1 100%;
					padding-top: 50px;
					width: 100px;
				}
				.time {
					order: 2;
					flex: 1 1 50px;
					width: calc(100% - 100px);
				}
				.text {
					order: 3;
					flex: 1 1 calc(100% - 50px);
					width: calc(100% - 100px);
				}
			}
		}
	}
}
</style>